import AppRouter from "./AppRouter";
import {observer} from "mobx-react";
import * as React from "react";
import {useEffect, useState} from "react";
import {ApplicationFactory} from "./Application";
import {ApplicationProvider} from "./ApplicationProvider";
import {SnackbarProvider} from "notistack";
import {ThemeProvider as MuiThemeProvider} from "@mui/material/styles";
import lightTheme from "./themes/lightTheme";

function App() {
    const [application, setApplicationInstance] = useState();

    useEffect(() => {
        const initializeApplication = async () => {
            const applicationFactory = new ApplicationFactory();
            const currentApplication = await applicationFactory.create();
            setApplicationInstance(currentApplication);
        };
        if (application === undefined) {
            initializeApplication();
        }
    }, []);

    return application &&
        <ApplicationProvider application={application}>
            <MuiThemeProvider theme={lightTheme}>
                <SnackbarProvider>
                    <AppRouter/>
                </SnackbarProvider>
            </MuiThemeProvider>
        </ApplicationProvider>
}

export default observer(App);
